import { AutocompleteField } from './AutocompleteField';
import { CheckboxField } from './CheckboxField';
import { DatePickerField } from './DatePickerField';
import { DecimalField } from './DecimalField';
import { FilesUploadField } from './FilesUploadField';
import { NumberField } from './NumberField';
import { PasswordField } from './PasswordField';
import { PhoneField } from './PhoneField';
import { PriceAndCurrencyField } from './PriceAndCurrencyField';
import { PriceField } from './PriceField';
import { QuantityField } from './QuantityField';
import { SwitchField } from './SwitchField';
import { TextField } from './TextField';
import { VerificationCodeField } from './VerificationCodeField';

export const fields = {
  Text: TextField,
  Number: NumberField,
  Switch: SwitchField,
  DatePicker: DatePickerField,
  Phone: PhoneField,
  Password: PasswordField,
  Checkbox: CheckboxField,
  Autocomplete: AutocompleteField,
  FilesUpload: FilesUploadField,
  PriceAndCurrency: PriceAndCurrencyField,
  VerificationCode: VerificationCodeField,
  Price: PriceField,
  Quantity: QuantityField,
  Decimal: DecimalField,
};
